<template>
  <div>
    <a
      v-stat:click="{
        key: 'index_originality_video_card_click',
        params: { o: data.id }
      }"
      :href="`https://hd.weibo.com/originality/view/${data.id}?alk_from=P006_C070`"
      target="_blank"
      class="ori-video-component"
    >
      <div class="video-content">
        <div class="poster-image">
          <img :src="cover.url" alt="微博营销 创意灵感" />
          <div class="play-btn" @click.stop.prevent="play">
            <i class="iconfont icon-kaishibofang"></i>
          </div>
          <div class="video-data app-flex-row-space-between">
            <span>{{ video.video_play_count | unit }}次观看</span>
            <span>{{ video.duration | duration }}</span>
          </div>
        </div>
      </div>
      <div class="footer app-flex-row-space-between">
        <div class="user-info">
          <div v-if="data.profile_image_url" class="avatar-img">
            <img
              v-lazy="data.profile_image_url"
              :alt="`微博营销 ${data.industry}`"
            />
            <span
              v-if="data.verified_type - 0 !== -1"
              class="vip-badge"
              :class="{ bluev: data.verified_type - 0 === 2 }"
            >
              <i class="iconfont icon-yonghushuxing"></i>
            </span>
          </div>
          <div class="user-main">
            <h3 class="name">{{ data.screen_name }}</h3>
            <p>
              <span v-if="data.followers_count">
                粉丝 {{ data.followers_count | unit }}
              </span>
            </p>
          </div>
        </div>
        <div class="relate-counts">
          <span v-if="data.repost_count > 0">
            转发 {{ data.repost_count | unit }} </span
          >,
          <span v-if="data.comment_count > 0">
            评论 {{ data.comment_count | unit }} </span
          >,
          <span v-if="data.attitude_count > 0">
            点赞 {{ data.attitude_count | unit }}
          </span>
        </div>
      </div>
    </a>
    <modal-base v-if="popShow" :lock-scroll="false" @wrapper-click="closeVideo">
      <div class="pop-video" :class="{ fullscreen: fullscreen }">
        <m-video
          :view-file="video"
          :auto-play="true"
          :muted="true"
          poster
          @fullscreen="fullScreenToggle"
        ></m-video>
      </div>
    </modal-base>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import ModalBase from '@/components/common/ModalBase'
import MVideo from '@/components/video/MVideo'

export default {
  components: {
    ModalBase,
    MVideo
  },
  filters: {
    unit(value, d = 1) {
      const si = [
        { value: 1, symbol: '' },
        { value: 1e4, symbol: '万' },
        { value: 1e8, symbol: '亿' }
      ]
      let i
      for (i = si.length - 1; i > 0; i--) {
        if (value >= si[i].value) {
          break
        }
      }
      value = (value / si[i].value)
        .toFixed(d)
        .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1')
      return value + si[i].symbol
    },
    duration(seconds) {
      const duration = dayjs.duration({ seconds })
      const pattern = seconds >= 3600 ? 'HH:mm:ss' : 'mm:ss'
      return dayjs(duration.asMilliseconds()).format(pattern)
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popShow: false,
      fullscreen: false
    }
  },
  computed: {
    video() {
      let videoList = this.data.video_list
      if (
        this.data.marketing_guidance &&
        this.data.marketing_guidance.length > 0
      ) {
        videoList = this.data.marketing_guidance[0].video_list
      }
      return videoList.length > 0 ? videoList[0] : {}
    },
    cover() {
      return this.video.cover || {}
    }
  },
  methods: {
    play() {
      this.popShow = true
      this.$stat({
        key: 'index_originality_video_play_click',
        params: { o: this.data.id }
      })
    },
    closeVideo() {
      this.popShow = false
    },
    fullScreenToggle(isFullscreen) {
      this.fullscreen = isFullscreen
    }
  }
}
</script>

<style lang="scss" scoped>
.ori-video-component {
  width: 572px;
  display: block;
  .poster-image {
    width: 100%;
    height: 322px;
    overflow: hidden;
    border-radius: 8px;
    position: relative;
    cursor: pointer;
    display: block;
    color: #ffffff;
    img {
      width: 100%;
      height: 100%;
      float: left;
      object-fit: cover;
    }
    .play-btn {
      width: 48px;
      height: 48px;
      line-height: 48px;
      text-align: center;
      background-color: #000000;
      position: absolute;
      top: 50%;
      left: 50%;
      margin: -24px 0 0 -24px;
      border-radius: 50%;
      cursor: pointer;
      i {
        font-size: 28px;
      }
    }
    .video-data {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 40px;
      line-height: 40px;
      padding: 0 12px;
      font-size: 13px;
      box-sizing: border-box;
      background-image: linear-gradient(
        180deg,
        rgba(0, 0, 0, 0) 0%,
        rgba(0, 0, 0, 0.65) 100%
      );
    }
  }
  .avatar-img {
    float: left;
    width: 42px;
    height: 42px;
    padding-right: 12px;
    box-sizing: content-box;
    position: relative;
    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
    .vip-badge {
      position: absolute;
      width: 14px;
      height: 14px;
      line-height: 15px;
      text-align: center;
      bottom: 0;
      right: 10px;
      border-radius: 50%;
      background-color: #ffa800;
      color: #ffffff;
      border: 2px solid #ffffff;
      i {
        font-size: 14px;
      }
      &.bluev {
        background-color: #2fb0f7;
      }
    }
  }
  .footer {
    margin-top: 16px;
    .user-info {
      display: flex;
    }
    .user-main {
      flex-direction: column;
      justify-content: center;
      height: 42px;
      .name {
        font-weight: normal;
        font-size: 12px;
        line-height: normal;
        color: #ffffff;
      }
      p {
        color: #727272;
        font-size: 12px;
        span {
          margin-right: 12px;
        }
      }
    }
  }
  .relate-counts {
    height: 30px;
    line-height: 31px;
    border-radius: 15px;
    padding: 0 16px;
    font-size: 14px;
    color: #efeff3;
    background-color: rgba(255, 255, 255, 0.1);
  }
}
.pop-video {
  width: 50%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  &.fullscreen {
    width: 100%;
    height: 100%;
  }
}
</style>
